import * as React from 'react';
import TextField from "@material-ui/core/TextField";
import { UserFilterSettingsModel } from "../../models/user/userFilterSettingsModel";
import Translate from '../../common/functions/translate';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import MenuItem from '@material-ui/core/MenuItem';
import { Role, UserActiveFilter } from '../../common/enums';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { DropdownModel } from '../../models/dropdownModel';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import RegionService from '../../services/regionService';
import { RegionModel } from '../../models/region';
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import Paper from '@material-ui/core/Paper';

interface UserFilterProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface UserFilterState {
  userSettings: UserFilterSettingsModel,
  filterText: string,
  roles: Array<DropdownModel>;
  regions: Array<DropdownModel>;
  actives: Array<DropdownModel>;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      }
    }
  },
  palette: {
    primary: blue
  }
});

export class UserFilter extends React.Component<UserFilterProps, UserFilterState>  {
  regionService = new RegionService();

  constructor(props) {
    super(props);
    this.state = {
      userSettings: new UserFilterSettingsModel(),
      filterText: '',
      roles: new Array<DropdownModel>(0),
      regions: new Array<DropdownModel>(0),
      actives: new Array<DropdownModel>(),
    };
  }

  componentDidMount() {
    const regions: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const roles: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 },];
    const actives: Array<DropdownModel> = [];

    this.regionService.getAllActiveRegions().then(
      (data: Array<RegionModel>) => {
        let regData = new Array<DropdownModel>(0);
        data.forEach(r => regData.push({ label: r.name, value: r.id }));

        this.setState({
          regions: regions.concat(regData),
          roles: roles.concat(HelperFunctions.enumToDropdownArray(Role, true)),
          actives: actives.concat(HelperFunctions.enumToDropdownArray(UserActiveFilter, true))
        });
      })
      .catch(error => {
        this.setState({
          roles: roles.concat(HelperFunctions.enumToDropdownArray(Role, true)),
          actives: actives.concat(HelperFunctions.enumToDropdownArray(UserActiveFilter, true))
        });
      });
  }

  handleChange = (key, value) => {
    if ((key === 'roleId' && value === 0) || (key === 'regionId' && value === 0)) {
      value = undefined;
    }

    const userSettings: UserFilterSettingsModel = { ...this.state.userSettings };
    userSettings[key] = value;
    const fiterText = this.generateFilterText(userSettings);
    this.setState({ userSettings: { ...userSettings }, filterText: fiterText });
  };

  generateFilterText = (settings: UserFilterSettingsModel) => {
    let result = '';

    if (settings.name) {
      result += Translate("User") + " <strong>'" + settings.name + "'</strong>, "
    }
    if (settings.email) {
      result += Translate("Email") + " <strong>'" + settings.email + "'</strong>, "
    }
    if (settings.roleId) {
      result += Translate("Role") + " <strong>'" + HelperFunctions.getEnumLabel(settings.roleId, Role, true) + "'</strong>, "
    }


    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      userSettings: new UserFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new UserFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.userSettings)
    }
  }

  render() {
    return (

      <Paper style={{ padding: 10, marginBottom: 15, backgroundColor: "#f5f5f5" }} >
        <div>
          <MuiThemeProvider theme={theme}>
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="name"
              label={Translate("Name")}
              style={{ marginRight: 10 }}
              type="text"
              onChange={(e) => this.handleChange('name', e.target['value'])}
              value={this.state.userSettings && this.state.userSettings.name ? this.state.userSettings.name : ""}
            />

            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="email"
              type="email"
              style={{ marginRight: 10 }}
              label={Translate("Email")}
              onChange={(e) => this.handleChange('email', e.target['value'])}
              value={this.state.userSettings && this.state.userSettings.email ? this.state.userSettings.email : ""}
            />

            <FormControl style={{ marginRight: 10 }}>
              <InputLabel htmlFor="role-label">{Translate('Role')}</InputLabel>
              <Select
                name="roleId"
                value={this.state.userSettings.roleId ? this.state.userSettings.roleId : ''}
                onChange={(e) => this.handleChange('roleId', e.target.value)}
                inputProps={{
                  id: 'role-label'
                }}
              >
                {
                  this.state.roles.map(m => <MenuItem key={m.value + 'role'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                }
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel htmlFor="category-label">{Translate('Region')}</InputLabel>
              <Select
                style={{ marginRight: 10 }}
                name="regionId"
                value={this.state.userSettings.regionId ? this.state.userSettings.regionId : ''}
                onChange={(e) => this.handleChange('regionId', e.target.value)}
                inputProps={{
                  id: 'category-label'
                }}
              >
                {
                  this.state.regions.map(m => <MenuItem key={m.value + 'region'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                }
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel htmlFor="active-label">{Translate('Active')}</InputLabel>
              <Select
                name="activeId"
                value={this.state.userSettings.actives ? this.state.userSettings.actives : ''}
                onChange={(e) => this.handleChange('actives', e.target.value)}
                inputProps={{
                  id: 'active-label'
                }}
              >
                {
                  this.state.actives.map(m => <MenuItem key={m.value + 'active'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                }
              </Select>
            </FormControl>
          </MuiThemeProvider>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
          <div style={{ fontSize: "0.9em" }}>
            {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
            {this.state.filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
          </div>
          <div>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: 10 }}
              size="small"
              onClick={() => this.handleSearchButtonClick(this.state.userSettings)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
              {Translate("Filter")}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => this.handleClearButtonClick()}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10 }} />
              {Translate("Clear")}
            </Button>
          </div>
        </div>
      </Paper>
    )
  }
}

export default UserFilter;
